// Function to scroll thumbnails
function scrollThumbnails(direction) {
  const wrapper = document.querySelector('.thumbnails-wrapper');
  const container = document.querySelector('.thumbnails-container');
  const scrollAmount = container.clientWidth;

  if (direction === 'next') {
    wrapper.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  } else if (direction === 'prev') {
    wrapper.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  }
}

// Show only the first <li> element and hide the rest
const mediaItems = document.querySelectorAll('.product__media-list li');

// Check if there are media items
if (mediaItems.length > 0) {
  mediaItems.forEach((item, index) => {
    if (index === 0) {
      item.style.display = 'block'; // Show the first item
    } else {
      item.style.display = 'none'; // Hide all other items
    }
  });
}

// Update main image when a thumbnail is clicked (if thumbnails are present)
document.querySelectorAll('.thumbnails-wrapper .product-media-container').forEach((thumbnail) => {
  thumbnail.addEventListener('click', () => {
    const clickedImageSrc = thumbnail.querySelector('img').src;

    document.querySelector('.main-image-container .product__media img').src = clickedImageSrc;
    document.querySelector('.main-image-container .product__media img').srcset = thumbnail.querySelector('img').srcset;
    document.querySelector('.main-image-container .product__media img').sizes = thumbnail.querySelector('img').sizes;
  });
});
